import React from "react";
import { Sprout, Hammer, Heart, Quote } from "lucide-react";
import { storyData } from "../mock";

const iconMap = { Sprout, Hammer, Heart };

const Story = () => {
  return (
    <section id="cerita" className="relative py-16">
      <div className="max-w-6xl mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-10 items-center">
          {/* Narrative */}
          <div>
            <span className="inline-block bg-[#FFF1E6] text-[#E8630C] text-xs font-bold px-4 py-2 rounded-full shadow-sm mb-4">
              {storyData.eyebrow}
            </span>
            <h2 className="text-3xl md:text-4xl font-extrabold text-[#004743] tracking-tight leading-tight">
              Berawal dari Dinding yang <span className="text-[#FD7A18]">Kosong</span>
            </h2>
            <p className="text-[#004743] font-bold mt-5 text-sm md:text-base leading-relaxed">
              {storyData.lead}
            </p>
            {storyData.paragraphs.map((p, i) => (
              <p
                key={i}
                className="text-[#6B857E] mt-4 text-sm md:text-base leading-relaxed"
              >
                {p}
              </p>
            ))}
            <div className="mt-6 bg-white rounded-[2rem] p-5 shadow-lg shadow-green-900/5 border-l-4 border-[#FD7A18] flex gap-3 items-start">
              <Quote className="w-6 h-6 text-[#FD7A18] shrink-0 mt-0.5" />
              <p className="text-sm md:text-base font-bold text-[#004743] italic leading-relaxed">
                {storyData.quote}
              </p>
            </div>
          </div>

          {/* Image */}
          <div className="relative">
            <div className="rounded-[2.5rem] overflow-hidden shadow-xl shadow-green-900/10 aspect-[4/5] max-h-[560px] w-full group">
              <img
                src={storyData.image}
                alt="Cerita ruangrasa"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                loading="lazy"
              />
            </div>
            <div className="absolute -top-4 -left-4 w-24 h-24 bg-[#FD7A18] rounded-full flex flex-col items-center justify-center text-white shadow-lg shadow-orange-500/30 rotate-[-8deg]">
              <span className="text-[10px] font-bold uppercase tracking-wider opacity-90">
                Est.
              </span>
              <span className="text-xl font-extrabold leading-none">2019</span>
            </div>
            <div className="absolute -bottom-5 right-6 bg-white rounded-3xl px-5 py-4 shadow-xl shadow-green-900/10 flex items-center gap-3">
              <div className="w-10 h-10 rounded-2xl bg-[#FFF1E6] flex items-center justify-center">
                <Heart className="w-5 h-5 text-[#FD7A18]" />
              </div>
              <div>
                <p className="text-sm font-extrabold text-[#004743]">
                  Handmade with Love
                </p>
                <p className="text-[10px] text-[#8AA59D]">
                  oleh pengrajin lokal Indonesia
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Milestones */}
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 md:gap-6 mt-14">
          {storyData.milestones.map((m) => {
            const Icon = iconMap[m.icon];
            return (
              <div
                key={m.year}
                className="bg-white rounded-[2rem] p-6 shadow-lg shadow-green-900/5 hover:-translate-y-1.5 hover:shadow-xl transition-all duration-300"
              >
                <div className="flex items-center gap-3 mb-3">
                  <div className="w-11 h-11 rounded-2xl bg-[#FFF1E6] flex items-center justify-center">
                    <Icon className="w-5 h-5 text-[#FD7A18]" />
                  </div>
                  <span className="text-2xl font-extrabold text-[#FD7A18]">
                    {m.year}
                  </span>
                </div>
                <h3 className="font-bold text-[#004743] text-base">{m.title}</h3>
                <p className="text-xs text-[#6B857E] mt-2 leading-relaxed">
                  {m.desc}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Story;
